import React from 'react';
import { tag } from '../../../model/tag';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';

interface IProps {
    tag: tag;
    handleClickOnTag: (tag: tag) => void;
    selected: boolean;
}

interface IState {
}

class TagItem extends React.Component<IProps, IState>
{
    render() {
        return (
            <>
                <ListItem key={this.props.tag.code} dense button onClick={(e) => this.props.handleClickOnTag(this.props.tag)}>
                    <ListItemIcon>
                        <Checkbox
                            checked={this.props.selected}
                            edge="start"
                            disableRipple
                        />
                    </ListItemIcon>
                    <ListItemText primary={this.props.tag.description} style={{ color: this.props.tag.color, padding: '5px' }} />
                </ListItem>
            </>
        )
    }
}

export default TagItem;
